import { render, staticRenderFns } from "./DocumentItemIcon.vue?vue&type=template&id=0c5fcc0e"
import script from "./DocumentItemIcon.vue?vue&type=script&lang=js"
export * from "./DocumentItemIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports